import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ContactUpdateEmailDiffRowResource } from "../../../../shared/types/contactUpdateInquiry";
import {
	ContactUpdateBaseRelationDiffRow,
	ContactUpdateInquiryDiffEntry,
	mapRelationEntry,
} from "./ContactUpdateBaseRelationDiffRow";
import { emailDiffEntryToIdentifier } from "./contactUpdateUtils";

interface Props {
	row: ContactUpdateEmailDiffRowResource;
}

export const ContactUpdateEmailDiffRow: FC<Props> = ({ row }) => {
	const { t } = useTranslation();
	const [field] = useField(`emails`);
	const value = field.value[row.currentContact.email];
	const identifier = emailDiffEntryToIdentifier(row.currentContact);

	const currentContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.currentContact),
		active: value === "currentContact",
		heading: t("Email address"),
		value: row.currentContact.email,
		onClick: () =>
			field.onChange({
				target: { name: field.name, value: { ...field.value, [identifier]: "currentContact" } },
			}),
	};

	const updatedContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.updatedContact),
		active: value === "updatedContact",
		heading: t("Email address"),
		value: row.updatedContact.email,
		onClick: () =>
			field.onChange({
				target: { name: field.name, value: { ...field.value, [identifier]: "updatedContact" } },
			}),
	};

	return <ContactUpdateBaseRelationDiffRow currentContact={currentContact} updatedContact={updatedContact} />;
};
